import {
  setIsCalculationTypesLoading,
  setUnifierCalculationTypesList,
} from "../../../features/unifierCalculationTypesSlice";
import { calculationTypesService } from "../../../services/api/calculation-types.endpoints";

async function getCollectionTypes(oauthTokenHeader: any, dispatch: any) {
  dispatch(setIsCalculationTypesLoading(true));
  try {
    const response =
      await calculationTypesService.getAllCollectionTypes(oauthTokenHeader);
    if (!response || !response.status) {
      throw new Error("Failed to access collection types");
    } else if (response.status === 200) {
      dispatch(setUnifierCalculationTypesList(response?.data?.data)); // Set the Calculation types list
      return response?.data;
    }
  } catch (e: any) {
    return e ? e?.parsedText : { reason: "Unknown error occurred." };
  } finally {
    dispatch(setIsCalculationTypesLoading(false));
  }
}

async function createNewCollectionTypes(oauthTokenHeader: string, data: any) {
  try {
    const response = await calculationTypesService.createCollectionTypes(
      oauthTokenHeader,
      data,
    );
    // Ensure response exists and check for both 200 and 201
    if (!response || !response.status) {
      return { reason: "Failed to create new calculation type." };
    }

    if (response.status === 201) {
      return response;
    } else {
      return { reason: `Unexpected status code: ${response.status}` };
    }
  } catch (e: any) {
    return e?.parsedText || { reason: "Unknown error occurred." };
  }
}

async function editCollectionTypes(
  oauthTokenHeader: string,
  data: any,
  collectionTypeId: any,
) {
  try {
    const response = await calculationTypesService.updateCollectionTypes(
      oauthTokenHeader,
      data,
      collectionTypeId,
    );
    // Ensure response exists and check for both 200 and 201
    if (!response || !response.status) {
      return { reason: "Failed to update calculation type." };
    }

    if (response.status === 200) {
      return response;
    } else {
      return { reason: `Unexpected status code: ${response.status}` };
    }
  } catch (e: any) {
    return e?.parsedText || { reason: "Unknown error occurred." };
  }
}

export const CalculationTypesEndPointLogic = {
  getCollectionTypes,
  createNewCollectionTypes,
  editCollectionTypes,
};
